import { CloudUploadOutlined } from '@ant-design/icons';
import { Button, Modal, Spin } from 'antd';
import { billingSelectors } from 'containers/App/selectors';
import { FC, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { t_medical_institution } from 'types';
import { getResultImport, importCSV } from '../../pages/BillingProcess/thunk';
import Wrap from './styles';

type Props = {
  text: string;
  updateHospital: () => Promise<void>;
};

const ButtonRegister: FC<Props> = ({ text, updateHospital }) => {
  const date = new Date();
  const dispatch = useDispatch();
  const dateNew = `${date.getFullYear()}年${date.getMonth()}月`;
  const location = useLocation<{ medicalDetail: t_medical_institution }>();
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const { fieldHospital, itemInvoice } = useSelector(billingSelectors);
  const [errUpload, setErrUpload] = useState('');

  const { getRootProps, getInputProps, fileRejections, acceptedFiles } = useDropzone({
    accept: '.csv',
  });
  const handleUpload = async () => {
    let optionFieldHospital: any[] = [];
    let error = '';
    setLoading(true);
    const textFile = await acceptedFiles[0].text();
    const resultField = fieldHospital?.find(([_key, value]: [string, any]) => value.display_id === 'hospital_visit');
    if (resultField) {
      optionFieldHospital = resultField[1]?.options ?? [];
    }
    const newCSVArr = textFile.split('\n');
    if (newCSVArr.length < 2) {
      setLoading(false);
      return;
    }
    for (let index = 1; index < newCSVArr.length - 1; index++) {
      const newData = newCSVArr[index].split(',').slice(2);
      const hospital_visit = optionFieldHospital.find((f) => f.value === newData[0]);
      if (!hospital_visit && newData[0] !== '') {
        error = '入力内容に誤りがあります';
        break;
      }
      if (hospital_visit && hospital_visit.display_id === 'o_yes') {
        if (!['受診', '受診（未受診分請求なし）', '請求不要'].includes(newData[2])) {
          error = '入力内容に誤りがあります';
          break;
        }
      }
      if (hospital_visit && hospital_visit.display_id === 'o_no') {
        if (!['未受診', '請求不要（未受診分請求なし）', '請求不要'].includes(newData[2])) {
          error = '入力内容に誤りがあります';
          break;
        }
      }
      if (newData[0] === '' && newData[2] !== '') {
        error = '入力内容に誤りがあります';
        break;
      }
    }
    if (error !== '') {
      acceptedFiles.splice(0, acceptedFiles.length);
      setErrUpload(error);
      setLoading(false);
      return;
    }

    setErrUpload('');
    const result: any = await dispatch(
      importCSV({
        file: textFile,
        filename: acceptedFiles[0].name,
        optionField: optionFieldHospital,
        invoice_month: itemInvoice?.invoice_month ?? '',
      }),
    );
    acceptedFiles.splice(acceptedFiles.indexOf(acceptedFiles[0]), 1);
    if (!result.payload) {
      setLoading(false);
      setErrUpload('データインポート中にエラーが発生しました。操作を中断し、システム管理会社にご連絡ください。');
    } else if (result.payload.result) {
      setLoading(false);
      updateHospital();
      setTimeout(() => {
        setModalVisible(false);
      }, 5000);
    } else if (result.payload.error) {
      setLoading(false);
      setErrUpload('データインポート中にエラーが発生しました。操作を中断し、システム管理会社にご連絡ください。');
    } else if (importCSV.fulfilled.match(result)) {
      const getStatusImport = async (stream_id: string) => {
        const resultImport: any = await dispatch(
          getResultImport({
            stream_id,
          }),
        );
        const obj = resultImport ? resultImport.payload : null;
        if (obj) {
          const status = obj[Object.keys(obj)[0]].status;

          if (status.id === 0 || status.id === 1) {
            getStatusImport(stream_id);
          } else if (status.id === 2) {
            setLoading(false);
            await updateHospital();
            setModalVisible(false);
          } else {
            setLoading(false);
            setErrUpload('エラーが発生しました。少し時間をおき、再度実行してください。');
          }
        }
      };
      getStatusImport(result.payload.stream_id);
    } else {
      setLoading(false);
      setErrUpload('エラーが発生しました。少し時間をおき、再度実行してください。');
    }
  };
  return (
    <Wrap>
      <Button onClick={() => setModalVisible(true)} className="btn-register standardFont">
        {text}
      </Button>
      <Modal
        title="受診状況をCSVで登録"
        centered
        visible={modalVisible}
        onOk={handleUpload}
        onCancel={() => setModalVisible(false)}
        okText="CSVを登録する"
        cancelText="キャンセル"
        width={1200}
        closable={false}
        maskClosable={false}
        okButtonProps={{
          type: 'link',
          disabled: true ? acceptedFiles.length === 0 || loading === true : false,
          className: acceptedFiles.length === 0 ? 'ant-btn-link' : 'ant-btn-primary',
        }}
        cancelButtonProps={{
          className: loading === true ? 'ant-btn-text' : 'ant-btn',
          disabled: true ? loading === true : false,
        }}
        bodyStyle={{ height: '350px', backgroundColor: '#eeeeee' }}
      >
        <p className="clinic-room middleBoldFont">
          {location.state.medicalDetail.facility_name} {`${dateNew}`}度の受診状況
        </p>
        <div className="upload-file-bill" {...getRootProps()}>
          <input {...getInputProps()} />
          {loading === true && acceptedFiles.length > 0 ? (
            <>
              <Spin size={'large'} />
              <p className="middleBoldFont" style={{ textAlign: 'center', marginTop: '2rem' }}>
                只今処理を行っています。
              </p>{' '}
              <p className="middleBoldFont" style={{ textAlign: 'center' }}>
                処理が完了するまでこのままお待ち下さい。
              </p>
            </>
          ) : (
            ''
          )}
          {acceptedFiles.length === 0 && loading === false ? (
            <>
              <CloudUploadOutlined className="svg" />
              <p className="middleBoldFont" style={{ marginTop: '0.5rem', marginBottom: 0 }}>
                インポートするCSVをここにドラッグ
              </p>
              <p className="middleBoldFont" style={{ textAlign: 'center', margin: '0.5rem' }}>
                または
              </p>
              <Button style={{ backgroundColor: '#d8d8d8', color: '#80a445', border: '1px solid #80a445' }}>
                ファイルを選択
              </Button>
              {errUpload && <p className="error-upload">{errUpload}</p>}
            </>
          ) : (
            <p>
              {acceptedFiles.map((file) => (
                <b>{loading === true ? '' : file.name}</b>
              ))}
              {fileRejections.map(({ file, errors }) => (
                <ul>
                  {errors.map((e) => (
                    <b>{e.message}</b>
                  ))}
                </ul>
              ))}
            </p>
          )}
        </div>
      </Modal>
    </Wrap>
  );
};

export default ButtonRegister;
